import { lazy } from "react";

export const BankingAndFinance = lazy(
  () => import("./BankingAndFinance/BankingAndFinance"),
);

export const BankingAndFinanceWalletFunding = lazy(
  () =>
    import("./BankingAndFinance/BankingAndFinanceWalletFunding/BankingAndFinanceWalletFunding"),
);

export const Profile = lazy(() => import("./MyAccount/Profile/Profile"));

export const MyAccountBankAndFinance = lazy(
  () => import("./MyAccount/BankAndFinance/BankAndFinance"),
);

export const Security = lazy(() => import("./MyAccount/Security/Security"));

export const AddressBook = lazy(
  () => import("./MyAccount/AddressBook/AddressBook"),
);

export const BuyerPaymentCompleted = lazy(
  () => import("./BuyerPaymentCompleted/BuyerPaymentCompleted"),
);

export const BuyerNotification = lazy(
  () => import("./BuyerNotification/BuyerNotification"),
);

//
export const AddBankAccount = lazy(
  () => import("./BankingAndFinance/AddBankAccount/AddBankAccount"),
);

export const BuyerOrderTrackingPage = lazy(
  () => import("./BuyerOrderTrackingPage/BuyerOrderTrackingPage"),
);

export const ContactUsPage = lazy(
  () => import("./ContactUsPage/ContactUsPage"),
);

export const MyAccount = lazy(() => import("./MyAccount/MyAccount"));

export const Main = lazy(() => import("./MyAccount/Main/Main"));

export const MyAccountWalletFunding = lazy(
  () =>
    import("./MyAccount/BankAndFinance/BankingAndFinance/BankingAndFinanceWalletFunding/BankingAndFinanceWalletFunding"),
);

export const MyAccountWalletWidthraw = lazy(
  () =>
    import("./MyAccount/BankAndFinance/BankingAndFinance/WalletWithdrawal/WalletWithdrawal"),
);
